import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../response.js';
import { getUploadTokenResponse } from './specs.js';

const getUploadToken = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, { scope , referenceId , recaptchaToken  }, init) {
        const formData = new FormData();
        formData.append('scope', scope);
        formData.append('referenceId', referenceId);
        if (recaptchaToken) {
            formData.append('recaptchaToken', recaptchaToken);
        }
        return validateResponse(getUploadTokenResponse, (yield fetch(`${apiUrl}/upload/token`, swcHelpers.objectSpread({
            method: 'POST',
            body: formData
        }, init))));
    });
    return function getUploadToken(apiUrl, _, init) {
        return _ref.apply(this, arguments);
    };
}();

export { getUploadToken };
//# sourceMappingURL=get-upload-token.js.map
